module.exports = __webpack_public_path__ + "static/media/logo-1.67c118df.svg";